import { NgModule } from '@angular/core';
import { SharedModule } from '@app/shared';
import { Utils } from '@src/utils/util';
import { ImpactAnalysisComponent} from '@app/authorized/project/impact-analysis/impact-analysis.component'
import {ImpactAnalysisChangesModule} from '@app/authorized/project/impact-analysis/impact-analysis-changes-ang7/impact-analysis-changes.module';
//import {ImpactAnalysisChangesModule} from './impact-analysis-changes-ang7/impact-analysis-changes.module'
import {ImpactAnalysisHeaderModule} from '@app/authorized/project/impact-analysis/impact-analysis-header-ang7/impact-analysis-header.module'
import {ImpactAnalysisPrecheckErrorsModule} from '@app/authorized/project/impact-analysis/impact-analysis-precheck-errors-ang7/impact-analysis-precheck-errors.module'
import {ImpactAnalysisDeploymentModule} from '@app/authorized/project/impact-analysis/impact-analysis-deployment-ang7/impact-analysis-deployment.module'
import {ImpactAnalysisScopesModule} from '@app/authorized/project/impact-analysis/impact-analysis-scopes-ang7/impact-analysis-scopes.module'
import {ImpactAnalysisPolicyModule} from '@app/authorized/project/impact-analysis/impact-analysis-policy-ang7/impact-analysis-policy.module'
//import { ImpactAnalysisPrecheckErrorsComponent } from './impact-analysis-precheck-errors-ang7/impact-analysis-precheck-errors';

@NgModule({
    imports: [SharedModule,ImpactAnalysisChangesModule,ImpactAnalysisHeaderModule,ImpactAnalysisPrecheckErrorsModule,ImpactAnalysisDeploymentModule,ImpactAnalysisScopesModule,ImpactAnalysisPolicyModule],
    declarations: [ImpactAnalysisComponent],
    entryComponents: [ImpactAnalysisComponent],
    exports: [ImpactAnalysisComponent],
    providers: [ Utils]
})

export class ImpactAnalysisModule{}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/project/impact-analysis/impact-analysis.module.ts